<script>
/**
 * input组件，主要对原生input进行样式封装，功能无较大变化
 */
import sizeMixin from "../../../utils/sizeMixin";
import formItemMixin from "../../../utils/formItemMixin";
export default {
  name: "SjInput",
  mixins: [sizeMixin, formItemMixin],
  props: {
    border: {
      type: Boolean,
      default: false
    },
    padding: {
      type: Number,
      default: 10
    },
    value: {
      type: [Number, String, File, Object]
    },
    dark: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    },
    textArea: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: "text"
    },
    cursor: {
      type: String,
      default: "text"
    },
    isFocus: {
      type: Boolean,
      default: false
    },
    isError: {
      type: Boolean,
      default: false
    },
    maxLength: {
      type: String,
      default: ""
    }
  },
  data() {
    return {};
  },
  methods: {
    /**
     * 原生方法封装
     */
    focus() {
      this.$el.focus();
    },
    blur() {
      this.$el.blur();
    },
    handleFileInput(ev) {
      const file = ev.target.files[0];
      this.$emit("input", file);
      this.$refs.file_input.value = null;
    }
  },
  render() {
    const {
      border,
      size,
      padding,
      value,
      dark,
      textArea,
      disabled,
      readonly,
      type,
      cursor,
      isFocus,
      isError,
      loading
    } = this;
    const attributes = {
      attrs: this.$attrs,
      on: {
        ...this.$listeners,
        input: e => {
          if (type !== "file") {
            this.$emit("input", e.target.value);
          }
        },
        focus: () => {
          // if (!readonly) {
          //   this.$el.removeAttribute("readonly");
          // }
          if (!loading) {
            this.$emit("focus");
          }
        }
      }
    };
    const style = {
      paddingLeft: padding ? `${padding}px` : undefined,
      paddingRight: padding ? `${padding}px` : undefined,
      cursor: disabled ? "not-allowed" : type === "file" ? "pointer" : cursor
    };

    let error = isError;
    if (this.validateState !== null) {
      error = error || !this.validateState;
    }

    /**
     * 根据props确定返回的元素和样式
     * 共textarea，text，file三种
     */
    return textArea ? (
      <textarea
        class={[
          "sj-input",
          `sj-input--${size}`,
          "sj-textArea",
          {
            border,
            dark,
            disabled,
            focus: isFocus,
            error
          }
        ]}
        style={style}
        autocomplete="off"
        disabled={disabled}
        readonly={readonly ? "readonly" : undefined}
        {...attributes}
        value={value}
      />
    ) : type === "file" ? (
      <div
        onClick={() => {
          if (!disabled) {
            this.$refs.file_input.click();
          }
        }}
        class={[
          "sj-input",
          {
            border,
            dark,
            disabled,
            focus: isFocus,
            error
          },
          `sj-input--${size}`,
          "file"
        ]}
        style={style}
        disabled={disabled}
        readonly={readonly ? "readonly" : undefined}
        {...attributes}
      >
        <input
          type="file"
          ref="file_input"
          class="file_input"
          onChange={this.handleFileInput}
          {...attributes}
        />
        {value ? (
          <span class="text">{value.name}</span>
        ) : (
          <span class="placeholder text">{this.$attrs.placeholder}</span>
        )}
      </div>
    ) : (
      <input
        class={[
          "sj-input",
          {
            border,
            dark,
            disabled,
            focus: isFocus,
            error
          },
          `sj-input--${size}`
        ]}
        maxlength={this.maxLength}
        style={style}
        autocomplete="off"
        disabled={disabled}
        readonly={readonly ? "readonly" : undefined}
        type={type}
        {...attributes}
        value={value}
      />
    );
  },
  watch: {
    // readonly(val) {
    //   if (this.$el && !val) {
    //     this.$nextTick(() => {
    //       this.$el.removeAttribute("readonly");
    //     });
    //   }
    // }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
.sj-input {
    background: transparent;
    box-sizing: border-box;
    border: 1px solid transparent;
    border-radius: @base-border-radius;
    color: @color-dark;
    font-weight: @regular-weight;
    width: 100%;

    &::placeholder {
        color: @color-normal;
    }

    &:focus,
    &.focus {
        outline: none;
        color: @color-available;
    }

    &.border {
        border-color: @color-gray-3;

        &:focus,
        &.focus {
            border-color: @color-highlight;
        }

        &.error {
            border-color: @color-alert-error;
        }
    }

    &.disabled {
        cursor: not-allowed;
        color: @color-light;

        &::placeholder {
            color: @color-light;
        }
    }

    each(@sizes, {
        &.sj-input--@{value} {
            .size(@value)
        }
    });
    /**
    &.sj-input--large {
      height: 50px;
      // padding: 0 20px;
      .text("body");
    }
    &.sj-input--medium {
      height: 40px;
      // padding: 0 20px;
      .text("body");
    }
    &.sj-input--default {
      height: 30px;
      // padding: 0 10px;
      .text("caption");
    }
    &.sj-input--small {
      height: 24px;
      // padding: 0 10px;
      .text("caption");
    }
    &.sj-input--mini {
      height: 20px;
      // padding: 0 10px;
      .text("caption");
    }
      **/

    &.dark {
        color: @color-antibg;

        &::placeholder {
            color: @color-light;
        }

        &:focus,
        &.focus {
            color: @color-antibg;
        }
    }

    &.sj-textArea {
        font-family: inherit;
        resize: none;
    }

    &.file {
        cursor: pointer;
        display: flex;
        align-items: center;

        .placeholder {
            color: @color-normal;
        }

        .file_input {
            display: none;
        }

        .text {
            .text-ellipsis();
        }
    }
}
</style>
